import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useStoreIsLoggedIn } from "../state/useAuthStore";

export const AuthGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const isLoggedIn = useStoreIsLoggedIn();
  if (!isLoggedIn) {
    return <Navigate to="/auth/login" replace />;
  }
  return <>{children}</>;
};
